import Button from 'antd/lib/button';
import React from 'react';
import { AppComponentProps } from '../../typescriptHelpers';
import { antGrey, runwayColors } from '../styles/globalStyles';
import { ArrowRightOutlined, ToolFilled, CloseOutlined } from '@ant-design/icons';
import { Link } from 'react-router-dom';
import { createQuickStartCIStepRoute } from '../../helpers/routeHelpers';
import Space from 'antd/lib/space';
import Text from 'antd/lib/typography/Text';
import Progress from 'antd/lib/progress';
import { NORMAL_APP_SEQUENCE, useFirstIncompleteQuickStartCIStep } from './hooks/useQuickStartCISteps';

export interface QuickStartCIProgressBannerProps extends AppComponentProps {
    onDismiss?: () => void;
}

export const QuickStartCIProgressBanner: React.FC<QuickStartCIProgressBannerProps> = ({ appId, orgId, onDismiss }) => {
    const [firstIncompleteStepIndex, stepCount] = useFirstIncompleteQuickStartCIStep(appId, orgId);

    return (
        <div
            style={{
                backgroundColor: antGrey.grey2,
                padding: '22px 30px',
                borderRadius: 8,
                border: `1px solid ${antGrey.grey5}`,
                marginBottom: 50,
                position: 'relative',
            }}
        >
            {onDismiss && (
                <Button
                    style={{
                        position: 'absolute',
                        right: 22,
                        top: 18,
                    }}
                    icon={<CloseOutlined style={{ color: antGrey.grey6, fontSize: 18 }} />}
                    onClick={onDismiss}
                    type="link"
                />
            )}
            <div
                style={{
                    display: 'flex',
                    gap: 30,
                    alignItems: 'center',
                }}
            >
                <ToolFilled
                    style={{
                        color: antGrey.grey5,
                        fontSize: 35,
                    }}
                />
                <Space
                    direction="vertical"
                    style={{
                        flex: 1,
                    }}
                    size={0}
                >
                    <Space size={10}>
                        <Text
                            style={{
                                color: antGrey.grey8,
                            }}
                        >
                            You’re almost done with your <strong>Quickstart CI/CD</strong> setup!
                        </Text>
                        <Link
                            to={createQuickStartCIStepRoute(
                                orgId,
                                appId,
                                NORMAL_APP_SEQUENCE[firstIncompleteStepIndex],
                            )}
                        >
                            <Space>
                                <Button
                                    type="link"
                                    style={{ padding: 0, display: 'inline', lineHeight: 'revert', fontWeight: 600 }}
                                >
                                    Continue
                                </Button>
                                <ArrowRightOutlined
                                    style={{
                                        color: runwayColors.primary,
                                    }}
                                />
                            </Space>
                        </Link>
                    </Space>
                    <Progress
                        style={{
                            width: '100%',
                        }}
                        className="quick-start-ci-progress"
                        percent={(firstIncompleteStepIndex / stepCount) * 100}
                        showInfo={false}
                        strokeColor={antGrey.grey8}
                    />
                </Space>
            </div>
        </div>
    );
};
